<template>
  <div class="oma-Content">
    <AppButton
      v-if="!isEmpty(formModel.elements)"
      v-tippy="{
        content: $t('dashboard.export_as_pdf'),
        placement: 'top',
        arrow: true,
        offset: [0, 14]
      }"
      data-export-ignore
      icon="export-pdf"
      remove-padding
      size="sm"
      type="ghost-next"
      @click="onExportPdfClick"
    />

    <AppRadioGroupCommon
      v-if="!isEmpty(formModel.elements)"
      v-model="layoutId"
      :name="`layoutOrientation-${formModel.id}`"
      :options="getLayoutTypeId"
      data-auto-testid="layout-switch"
      data-export-ignore
      data-testid="layout-switch"
      gap="0px"
      style="--option-padding: 0"
    />

    <ModuleDropdownMenu v-if="canEdit" :form-model="formModel" />
  </div>
</template>

<script setup>
import { isEmpty } from 'lodash'
import { inject } from 'vue'

import { getLayoutTypeId } from '@/utils/custom-dashboard-helper'
import { customDashboardStateInjectionKey } from '@/utils/injection-keys'

import ModuleDropdownMenu from '@/components/dashboard/custom-dashboard/modules/moduleActions/ModuleDropdownMenu'
import AppButton from '@/components/ui/AppButton/AppButton'
import AppRadioGroupCommon from '@/components/ui/AppRadioGroup/AppRadioGroupCommon'

defineOptions({
  name: 'OkrModuleActions'
})

const props = defineProps({
  formModel: {
    type: Object,
    default: () => ({})
  },

  canEdit: {
    type: Boolean
  }
})

const layoutId = defineModel('layoutId', {
  type: [String, Number],
  default: null,
  set: value => value
})

const customDashboardState = inject(customDashboardStateInjectionKey)

const onExportPdfClick = () => {
  customDashboardState.value.exportModule({
    moduleId: props.formModel.id,
    moduleName: props.formModel.name
  })
}
</script>

<style lang="scss" scoped>
.oma-Content {
  display: flex;
  align-items: center;
  gap: 8px;
}
</style>
